import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk,authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function storeslocationsSave(locations) {
  return {
    type: constants.STORE_LOCATIONS_SAVE,
    locations
  };
}

export function storesSetSelectedLocation(location) {
	return {
		type: constants.STORE_SELECT_LOCATION,
    location
	}
}


/******************************
*******  Asynchronous  ********
******************************/

export function fetchLocations() {
	return dispatch => {
		let url = api.API_URL + endpoint.LOCATIONS_FETCH;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function fetchAssociatebyLocation(locationId) {
	return dispatch => {
		let url = api.API_URL + endpoint.ASSOCIATES_FETCH + '?lid=' + locationId;
		return fetch(url, {
		  method: 'get',
		  headers: api.HEADERS
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}